module.exports = __webpack_public_path__ + "static/media/AppDownLoadImage03.58867e90.png";